export default "__VITE_ASSET__BA6BLzZw__"